// extracted by mini-css-extract-plugin
export default {"root":"ToggleSwitchInput_root__VAU40","logo":"ToggleSwitchInput_logo__HxFRK","content":"ToggleSwitchInput_content__OiR42","noMaxWidth":"ToggleSwitchInput_noMaxWidth__gIj6Y"};